import { BANNER_ASSOCIATION_ID_TYPES, BANNER_DISPLAY_EVERYWHERE_ID, BANNER_PREFERENCE_TYPE, GROUP_BANNER_PREFERENCE_TYPE } from "src/constants/AppConstants"
import { listPreference, listPreferenceByPreferenceType } from "../../utilities/AppSyncPlusAPIs"
import { AdminBanner, AdminBannerFromPreference, BannerAssociationId, PreferenceByTypeSuccessResponse, PreferenceSuccessResponse } from "src/Ateam-BI/Banners/BannerTypes"

const getBannersByPreferenceType = (preferenceType: string): Promise<AdminBanner[]> => {
    return new Promise((resolve, reject) => {
        listPreferenceByPreferenceType(preferenceType,
            (successResponse: PreferenceByTypeSuccessResponse) => {
                const items = successResponse?.data?.listPreferenceByPreferenceType?.items
                if (items) {
                    const banners = items?.map((item: AdminBannerFromPreference) => {
                        return {
                            ...item,
                            information: JSON.parse(item.information)
                        }
                    })
                    resolve(banners)
                }
            },
            (errorResponse: string) => {
                reject(errorResponse)
            }
        )
    }) 
}

const getBanners = (associationId: BannerAssociationId, associationIdType: string): Promise<AdminBanner[]> => {
    return new Promise((resolve, reject) => {
        listPreference(associationId, associationIdType, BANNER_PREFERENCE_TYPE,
            (successResponse: PreferenceSuccessResponse) => {
                const items = successResponse?.data?.listPreference?.items
                if (items) {
                    const banners = items?.map((item: AdminBannerFromPreference) => {
                        return {
                            ...item,
                            information: JSON.parse(item.information)
                        }
                    })
                    resolve(banners)
                }
            },
            (errorResponse: string) => {
                reject(errorResponse)
            }
        )
    })
}

export const getSingleBanners = async (): Promise<AdminBanner[]> => {
    return await getBannersByPreferenceType(BANNER_PREFERENCE_TYPE)
}

export const getGroupBanners = async (): Promise<AdminBanner[]> => {
    return await getBannersByPreferenceType(GROUP_BANNER_PREFERENCE_TYPE)
}

export const getDisplayEverywhereBanners = async (): Promise<AdminBanner[]> => {
    return await getBanners(BANNER_DISPLAY_EVERYWHERE_ID, BANNER_ASSOCIATION_ID_TYPES.ABC)
}

export const getClosePortalBanners = async (closePortalOwnerId: BannerAssociationId): Promise<AdminBanner[]> => {
    return await getBanners(closePortalOwnerId, BANNER_ASSOCIATION_ID_TYPES.CLOSE_PORTAL)
}

export const getEverywhereClosePortalBanners = async (): Promise<AdminBanner[]> => {
    return await getClosePortalBanners(BANNER_DISPLAY_EVERYWHERE_ID)
}

export const getUrlPrefixBanners = async (urlPrefix: BannerAssociationId): Promise<AdminBanner[]> => {
    return await getBanners(urlPrefix, BANNER_ASSOCIATION_ID_TYPES.URL_PREFIX)
}

export const getAppBanners = async (appId: BannerAssociationId): Promise<AdminBanner[]> => {
    return await getBanners(appId, BANNER_ASSOCIATION_ID_TYPES.APP)
}

export const getEverywhereAppBanners = async (): Promise<AdminBanner[]> => {
    return await getAppBanners(BANNER_DISPLAY_EVERYWHERE_ID)
}

export const getFriscoBanners = async (friscoId: BannerAssociationId): Promise<AdminBanner[]> => {
    return await getBanners(friscoId, BANNER_ASSOCIATION_ID_TYPES.FRISCO)
}

export const getEverywhereFriscoBanners = async (): Promise<AdminBanner[]> => {
    return await getFriscoBanners(BANNER_DISPLAY_EVERYWHERE_ID)
}

export const getFlexicoBanners = async (flexicoId: BannerAssociationId): Promise<AdminBanner[]> => {
    return await getBanners(flexicoId, BANNER_ASSOCIATION_ID_TYPES.FLEXICO)
}

export const getEverywhereFlexicoBanners = async (): Promise<AdminBanner[]> => {
    return await getFlexicoBanners(BANNER_DISPLAY_EVERYWHERE_ID)
}

export const getLogicoBanners = async (logicoId: BannerAssociationId): Promise<AdminBanner[]> => {
    return await getBanners(logicoId, BANNER_ASSOCIATION_ID_TYPES.LOGICO)
}

export const getEverywhereLogicoBanners = async (): Promise<AdminBanner[]> => {
    return await getLogicoBanners(BANNER_DISPLAY_EVERYWHERE_ID)
}
